const CompanyYTD = () => {
  return (
    <div className="text-greenFont font-[32px]">Company YTD: $6,327,183</div>
  );
};

export { CompanyYTD };
